import { styled } from '@mui/material/styles'

export const NoteContainerStyles = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.customBorderRadius.main,
  padding: '8px',
  marginTop: '12px',
}))

export const NoteHeaderStyles = styled('div')(({ theme }) => ({
  fontSize: '12px',
  fontWeight: '500',
  lineHeight: '12px',
  color: theme.palette.common.black,
  display: 'flex',
}))

export const NoteSubTitleStyles = styled('p')(({ theme }) => ({
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '12px',
  color: theme.palette.text.secondary, //theme.GREY
  marginLeft: '8px',
}))

export const NoteContentStyles = styled('div')(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '18px',
  color: theme.palette.common.black, //theme.BLACK_0,
  marginTop: '8px',
  fontWeight: '400',
}))

export const NoteNameStyles = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
  marginRight: '4px',
  textDecoration: 'none',
  cursor: 'pointer', //Added
  '&:hover': {
    //Added
    textDecoration: 'underline',
  },
}))
